module.exports = __webpack_public_path__ + "img/AI (2).f80a5cb4.png";